<router-outlet></router-outlet>
<div class="spinner">
    <div class="spin-c">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
<app-footer></app-footer>